import {VehicleMileageAction} from '@dms/api/sales';

interface MileageValues {
  mileageBefore: number | null | undefined;
  mileageAfter: number | null | undefined;
}

export interface MileageUpdateCommand {
  recordId: string;
  milage: number;
  action: VehicleMileageAction;
}

export interface GetMileageUpdateCommandsInput {
  recordId: string;
  previousValues: MileageValues;
  submittedValues: MileageValues;
}

const normalizeMileage = (value: number | null | undefined) => {
  if (value === null || value === undefined || value === 0) {
    return null;
  }

  return value;
};

const isMileageChanged = (
  previousValue: number | null | undefined,
  submittedValue: number | null | undefined
) => normalizeMileage(previousValue) !== normalizeMileage(submittedValue);

export const getMileageUpdateCommand = (
  input: GetMileageUpdateCommandsInput
): MileageUpdateCommand | null => {
  const normalizedBefore = normalizeMileage(input.submittedValues.mileageBefore);
  const normalizedAfter = normalizeMileage(input.submittedValues.mileageAfter);

  const isBeforeChanged =
    normalizedBefore !== null &&
    isMileageChanged(input.previousValues.mileageBefore, input.submittedValues.mileageBefore);

  const isAfterChanged =
    normalizedAfter !== null &&
    isMileageChanged(input.previousValues.mileageAfter, input.submittedValues.mileageAfter);

  if (isBeforeChanged && isAfterChanged) {
    const milage = Math.max(normalizedBefore, normalizedAfter);
    const action: VehicleMileageAction =
      milage === normalizedAfter ? 'test-drive-return' : 'test-drive-handover';

    return {recordId: input.recordId, milage, action};
  }

  if (isAfterChanged) {
    return {recordId: input.recordId, milage: normalizedAfter, action: 'test-drive-return'};
  }

  if (isBeforeChanged) {
    return {recordId: input.recordId, milage: normalizedBefore, action: 'test-drive-handover'};
  }

  return null;
};
